import { Link } from "@chakra-ui/react";

type Props = {
  count: number;
  onDelete: () => void;
  entity?: string;
};

/** Inline red "Delete N items..." link, visible only when at least one row is
 * selected. Designed to sit on the same row as the basic/advanced search
 * toggle inside the filter card. */
export default function BulkDeleteBar({ count, onDelete, entity = "item" }: Props) {
  if (count <= 0) return null;
  const label = `Delete ${count} ${entity}${count === 1 ? "" : "s"}...`;
  return (
    <Link
      color="red.600"
      fontSize="sm"
      onClick={(e) => {
        e.preventDefault();
        onDelete();
      }}
      href="#"
    >
      {label}
    </Link>
  );
}
